import React from "react";
import { Download, Printer, FileText, Mail } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

const FLYERS = [
  {
    file: "Studio_Euclides_Carte_Remerciement_A5.pdf",
    title: "Carte de remerciement",
    subtitle: "A5 paysage · à glisser dans les livraisons photo",
    desc: "Message « Merci. Vraiment. » + QR portfolio + coordonnées. Imprime recto, découpe au massicot. Idéal 170-250 g/m².",
    useCase: "Dans les enveloppes de livraison, les coffrets USB, les tirages print",
    accent: "#c8821f",
  },
  {
    file: "Studio_Euclides_Flyer_Reservation_A5.pdf",
    title: "Flyer Réserver une séance",
    subtitle: "A5 portrait · générique toute l'année",
    desc: "Hero « Révéler ce que tu es. Vraiment. » + 4 services + 3 avantages + QR vers /reservation. À avoir en permanence sur la table d'accueil.",
    useCase: "Table d'accueil, salons locaux, partenariats",
    accent: "#c8821f",
  },
];

export default function AdminKitImprimes() {
  return (
    <div className="text-text-cream" data-testid="admin-kit-imprimes">
      <div className="mb-10">
        <div className="eyebrow mb-2">Admin</div>
        <h1 className="font-serif text-4xl" data-testid="print-kit-title">Kit imprimés</h1>
        <p className="text-text-cream/50 mt-2 text-sm font-light max-w-2xl">
          Flyers A5 prêts à imprimer. QR codes vers tes pages live et coordonnées à jour.
          Papier conseillé : 170-250 g/m² mat ou soyeux.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {FLYERS.map(f => (
          <div
            key={f.file}
            className="bg-white/[0.03] border border-white/10 rounded overflow-hidden flex flex-col"
            data-testid={`flyer-card-${f.file}`}
          >
            <div className="aspect-[3/4] bg-dark relative flex items-center justify-center border-b border-white/5">
              <embed
                src={`${BASE}/downloads/${f.file}#toolbar=0&navpanes=0`}
                type="application/pdf"
                className="w-full h-full"
                data-testid={`preview-${f.file}`}
              />
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <h3 className="font-serif text-xl" style={{ color: f.accent }} data-testid={`title-${f.file}`}>{f.title}</h3>
              <p className="text-xs text-text-cream/50 mt-1 mb-3">{f.subtitle}</p>
              <p className="text-sm text-text-cream/70 font-light leading-relaxed mb-3">{f.desc}</p>
              <div className="text-xs text-text-cream/50 mb-4 pt-3 border-t border-white/5">
                <strong className="text-text-cream/70">À placer où :</strong> {f.useCase}
              </div>
              <div className="mt-auto flex gap-2">
                <a
                  href={`${BASE}/downloads/${f.file}`}
                  download
                  className="btn-primary flex-1 justify-center"
                  data-testid={`download-${f.file}`}
                >
                  <Download size={14} className="mr-2"/> Télécharger
                </a>
                <a
                  href={`${BASE}/downloads/${f.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost"
                  title="Ouvrir dans un nouvel onglet"
                  data-testid={`open-${f.file}`}
                >
                  <Printer size={14}/>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-accent-deep/5 border border-accent-deep/20 rounded p-6 max-w-3xl">
        <div className="flex items-start gap-4">
          <Printer size={22} className="text-accent-light flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-serif text-xl mb-3">Conseils d'impression</h3>
            <ul className="text-sm text-text-cream/70 font-light space-y-2">
              <li><strong className="text-text-cream/90">Format</strong> : A5 (148 × 210 mm) · 1 page recto</li>
              <li><strong className="text-text-cream/90">Papier</strong> : 170-250 g/m² mat ou soyeux (évite le brillant qui réfléchit)</li>
              <li><strong className="text-text-cream/90">Imprimeur</strong> : <a href="https://www.vistaprint.ch" target="_blank" rel="noopener noreferrer" className="text-accent-light">Vistaprint</a>, <a href="https://www.flyeralarm.ch" target="_blank" rel="noopener noreferrer" className="text-accent-light">Flyeralarm</a>, ou imprimerie locale (Lausanne/Renens)</li>
              <li><strong className="text-text-cream/90">Quantité suggérée</strong> : 50 pour commencer</li>
              <li><strong className="text-text-cream/90">Finition</strong> : coins arrondis facultatifs (plus premium, +5-10 CHF)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
